var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('b-icon',{attrs:{"size":"is-large","icon":"sync-alt","custom-class":"fa-spin fa-5x"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }